var React = require('react');

function IconDistribution (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M738.766 599.117c38.414 0 67.225 14.405 91.233 38.414 24.009 24.009 38.414 57.621 38.414 91.233 0 72.026-57.621 129.647-129.647 129.647S609.119 800.79 609.119 728.764c0-14.405 4.802-28.811 4.802-43.216l-139.251-81.63-4.802 4.802c-38.414 33.612-81.63 52.819-129.647 52.819-96.035 0-177.665-81.63-177.665-177.665s81.63-177.665 177.665-177.665c48.018 0 96.035 19.207 124.846 52.819l4.802 4.802L609.12 282.2c0-14.405-4.802-28.811-4.802-43.216 0-72.026 57.621-129.647 129.647-129.647s129.647 57.621 129.647 129.647-57.621 129.647-129.647 129.647c-38.414 0-67.224-14.405-91.233-38.414l-139.251 81.63c9.603 24.009 14.405 48.018 14.405 72.026 0 24.009-4.802 48.018-14.405 72.026l139.251 81.63c24.008-24.007 57.62-38.412 96.034-38.412z"}));
}

IconDistribution.displayName = "IconDistribution";

IconDistribution.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconDistribution;

IconDistribution.default = IconDistribution;
